<template>
  <div class="page-header">
    <div class="row">
      <div class="col">
        <h3 class="page-title">{{ title }}</h3>
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="admin-dashboard">{{ path }}</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="employees">{{ text }}</router-link>
          </li>
          <li class="breadcrumb-item active">{{ text1 }}</li>
        </ul>
      </div>
      <div class="col-auto float-end ms-auto" v-if="isShiftSchedulingRoute">
        <!-- <a
          class="list-view btn btn-link btn-primary mr-3"
          data-bs-toggle="modal"
          data-bs-target="#daliy_schedule_manage_colvis"
          style="margin-right: 5px"
          title="colvis"
          v-if="isShiftSchedulingRoute"
          ><i class="fa-solid fa-bars"></i
        ></a> -->
        <div class="btn-group m-r-5" v-if="hasScheduleExportPermission">
          <a
            class="btn dropdown-toggle export-btn"
            style="border-radius: 50px"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Export
          </a>
          <ul class="dropdown-menu export-dropdown">
            <li>
              <a
                class="dropdown-item"
                href="javascript:;"
                @click="exportReport('export-shift-scheduling', 'excel')"
              >
                Export as Excel
              </a>
            </li>
            <li>
              <a
                class="dropdown-item"
                href="javascript:;"
                @click="exportReport('export-shift-scheduling', 'pdf')"
              >
                Export as PDF
              </a>
            </li>
          </ul>
        </div>

        <router-link
          v-if="hasShiftReadPermission"
          to="shift-list"
          class="btn add-btn m-r-5 mb-1"
          >{{ text2 }}</router-link
        >
        <!-- Copy Week Dropdown -->
        <div class="btn-group m-r-5" v-if="hasScheduleExportPermission">
          <button
            type="button"
            class="btn dropdown-toggle add-btn export-btn"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Copy Week
          </button>
          <ul class="dropdown-menu export-dropdown">
            <li>
              <span class="dropdown-item text-muted disabled">
                {{ formattedCurrentWeek }}
              </span>
            </li>
            <li v-for="(week, index) in weekOptions" :key="index">
              <a
                class="dropdown-item"
                href="javascript:;"
                @click="copyWeek(week)"
              >
                {{ week.label }}
              </a>
            </li>
          </ul>
        </div>
        <a
          href="javascript:;"
          class="btn add-btn m-r-5 mb-1"
          data-bs-toggle="modal"
          data-bs-target="#add_schedule"
          v-if="hasScheduleCreatePermission"
        >
          {{ text3 }}</a
        >
        <a
          href="javascript:;"
          class="btn add-btn m-r-5"
          data-bs-toggle="modal"
          data-bs-target="#add_dept_schedule"
          v-if="hasScheduleCreatePermission"
        >
          {{ text4 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isShiftListRoute">
        <a
          @click="onAddShift"
          v-if="hasShiftCreatePermission"
          href="javascript:;"
          class="btn add-btn m-r-5"
          data-bs-toggle="modal"
          data-bs-target="#add_shift"
          >{{ text2 }}</a
        >
        <a
          @click="onAddSchedule"
          v-if="hasScheduleCreatePermission"
          href="javascript:;"
          class="btn add-btn m-r-5"
          data-bs-toggle="modal"
          data-bs-target="#add_schedule"
        >
          {{ text3 }}</a
        >
        <a
          @click="onAddDeptSchedule"
          v-if="hasScheduleCreatePermission"
          href="javascript:;"
          class="btn add-btn m-r-5"
          data-bs-toggle="modal"
          data-bs-target="#add_dept_schedule"
        >
          {{ text4 }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { notification } from "ant-design-vue";
import axios from "axios";
import moment from "moment";

export default {
  emits: ["add-shift", "add-schedule", "add-dept-schedule", "copy-week"],
  props: {
    title: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    text1: {
      type: String,
      default: "",
    },
    text2: {
      type: String,
      default: "",
    },
    text3: {
      type: String,
      default: "",
    },
    text4: {
      type: String,
      default: "",
    },
    currentWeekStart: {
      type: String,
      required: true,
    },
    currentWeekEnd: {
      type: String,
      required: true,
    },
    search_data: { type: Object, default: null, required: false },
    columns: { type: Array, default: null, required: false },
  },
  data() {
    return {
      hasShiftCreatePermission: null,
      hasShiftReadPermission: null,
      hasScheduleCreatePermission: null,
      hasScheduleExportPermission: null,
      weekOptions: [],
    };
  },
  computed: {
    isShiftSchedulingRoute() {
      //return this.$route.path === "/shift-scheduling";
	  return ["/shift-scheduling", "/shift-scheduling3"].includes(this.$route.path);
    },
    isShiftListRoute() {
      return this.$route.path === "/shift-list";
    },
    formattedCurrentWeek() {
      return `Copy ${moment(this.currentWeekStart).format("MMM DD")} - ${moment(
        this.currentWeekEnd
      ).format("MMM DD")} to:`;
    },
  },
  methods: {
    onAddShift() {
      this.$emit("add-shift");
    },
    onAddSchedule() {
      this.$emit("add-schedule");
    },
    onAddDeptSchedule() {
      this.$emit("add-dept-schedule");
    },
    // exportReport(report) {
    //   console.log(report);

    //   var searchData = null;
    //   var col_params = null;
    //   var url = `${process.env.VUE_APP_API_BASE_URL}report/${report}`;

    //   console.log(url);

    //   if (this.search_data && this.search_data != null) {
    //     searchData = Object.keys(this.search_data)
    //       .map(
    //         (key) =>
    //           `${encodeURIComponent(key)}=${encodeURIComponent(
    //             this.search_data[key]
    //           )}`
    //       )
    //       .join("&");
    //   }

    //   if (this.columns?.length) {
    //     var columns_keys = this.columns.map((column) => column.key);
    //     col_params = new URLSearchParams({
    //       keys: columns_keys.join(","),
    //     }).toString();
    //   }

    //   if (searchData != null) {
    //     url = `${process.env.VUE_APP_API_BASE_URL}report/${report}?${searchData}`;

    //     if (col_params != null) {
    //       url += `&${col_params}`;
    //     }
    //   } else {
    //     if (col_params != null) {
    //       url = `${process.env.VUE_APP_API_BASE_URL}report/${report}?${col_params}`;
    //     }
    //   }
    //   window.location.href = url;
    // },
    exportReport(report, type) {
      const token = window.localStorage.getItem("token");

      let url = `${process.env.VUE_APP_API_BASE_URL}report/${report}`;
      const params = new URLSearchParams();

      if (this.search_data && Object.keys(this.search_data).length > 0) {
        Object.entries(this.search_data).forEach(([key, value]) => {
          if (value !== null && value !== "") {
            params.append(key, value);
          }
        });
      }

      if (this.columns?.length) {
        const columnKeys = this.columns.map((col) => col.key);
        params.append("keys", columnKeys.join(","));
      }

      if (type) {
        params.append("export_type", type);
      }

      url += `?${params.toString()}`;
      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get(url, {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });

          const fileUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = fileUrl;

          let fileName =
            type === "pdf"
              ? "Shift_Schedule_Data.pdf"
              : "Shift_Schedule_Data.xlsx";

          const contentDisposition = response.headers["content-disposition"];
          if (contentDisposition) {
            const matches = contentDisposition.match(/filename="?([^"]+)"?/);
            if (matches && matches[1]) {
              fileName = matches[1];
            }
          }

          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          link.remove();
          URL.revokeObjectURL(fileUrl);
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch(() => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    generateWeekOptions() {
      const options = [];
      const currentStart = moment(this.currentWeekStart);

      for (let i = 1; i <= 3; i++) {
        const start = moment(currentStart).add(i * 7, "days");
        options.push({
          type: "future",
          startDate: start.format("YYYY-MM-DD"),
          endDate: moment(start).add(6, "days").format("YYYY-MM-DD"),
          label: `${start.format("MMM DD")} - ${moment(start)
            .add(6, "days")
            .format("MMM DD")}`,
        });
      }

      this.weekOptions = options;
    },

    copyWeek(week) {
      this.$emit("copy-week", {
        startDate: week.startDate,
        endDate: week.endDate,
      });
    },
  },
  watch: {
    currentWeekStart() {
      this.generateWeekOptions();
    },
  },
  mounted() {
    this.$store
      .dispatch("userPermissions", { module: "shift", action: "create" })
      .then((response) => {
        this.hasShiftCreatePermission = null;
        this.$nextTick(() => {
          this.hasShiftCreatePermission = response === "true";
        });
      });
    this.$store
      .dispatch("userPermissions", { module: "shift", action: "read" })
      .then((response) => {
        this.hasShiftReadPermission = null;
        this.$nextTick(() => {
          this.hasShiftReadPermission = response === "true";
        });
      });
    this.$store
      .dispatch("userPermissions", { module: "schedule", action: "create" })
      .then((response) => {
        this.hasScheduleCreatePermission = null;
        this.$nextTick(() => {
          this.hasScheduleCreatePermission = response === "true";
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "schedule", action: "export" })
      .then((response) => {
        this.hasScheduleExportPermission = null;
        this.$nextTick(() => {
          this.hasScheduleExportPermission = response === "true";
        });
      });

    this.generateWeekOptions();
  },
};
</script>
<style scoped>
.export-btn {
  background-color: #ff9b44 !important;
  color: #fff !important;
  border: none;
}

.export-btn:hover,
.export-btn:focus {
  background-color: #e78836 !important;
  color: #fff !important;
}

.export-dropdown {
  border-radius: 10px;
  overflow: hidden;
  padding: 0;
  min-width: 160px;
}

.export-dropdown .dropdown-item {
  padding: 10px 15px;
  color: #333;
  background-color: #fff !important;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.export-dropdown .dropdown-item:hover {
  background-color: #ff9b44 !important;
  color: #fff !important;
}
</style>
